import React from 'react';
import { CheckIcon } from 'lucide-react';
const Pricing = () => {
  const features = ['Automated bill payments', '30-day payment terms', 'Email & WhatsApp support', 'Comprehensive reporting', 'Multi-level approvals', 'Vendor management', 'Accounting integrations', 'API access for custom needs', 'Dedicated account manager (for enterprise)'];
  return <section id="pricing" className="section" data-id="element-183">
      <div className="container" data-id="element-184">
        <div className="text-center mb-16" data-id="element-185">
          <h2 className="font-outfit font-bold text-3xl md:text-4xl mb-6" data-id="element-186">
            Simple, Transparent Pricing
          </h2>
          <p className="text-slate-grey text-lg max-w-3xl mx-auto" data-id="element-187">
            Focus on running your business, not managing payments. All plans
            include our 30-day payment terms.
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-188">
          <div className="card relative border-2 border-settl-blue shadow-lg" data-id="element-189">
            {/* Popular Tag */}
            <div className="absolute top-0 inset-x-0 transform -translate-y-1/2 flex justify-center" data-id="element-190">
              <div className="bg-alert-orange text-white text-xs font-bold px-4 py-1 rounded-full uppercase" data-id="element-191">
                Most Popular
              </div>
            </div>
            <div className="text-center mb-8" data-id="element-192">
              <h3 className="font-outfit font-semibold text-2xl mb-4" data-id="element-193">
                Custom Pricing Based On Your Needs
              </h3>
              <p className="text-xl text-slate-grey" data-id="element-194">
                as low as 0.5% per Invoice
              </p>
            </div>
            <div className="mb-8" data-id="element-195">
              <div className="font-medium mb-4 text-lg text-center" data-id="element-196">
                What's included:
              </div>
              <ul className="space-y-3 flex flex-col items-center" data-id="element-197">
                {features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-198">
                    <CheckIcon className="h-5 w-5 text-success-green mr-3 flex-shrink-0 mt-0.5" data-id="element-199" />
                    <span data-id="element-200">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-201">
              <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-primary" data-id="element-202">
                Start Free Trial
              </a>
              <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-secondary" data-id="element-203">
                Contact Sales
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center bg-light-sky rounded-xl p-6 max-w-2xl mx-auto" data-id="element-204">
          <div className="flex items-center justify-center mb-4" data-id="element-205">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 text-settl-blue mr-2" data-id="element-206">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-207" />
            </svg>
            <span className="font-medium" data-id="element-208">100% Satisfaction Guarantee</span>
          </div>
          <p className="text-slate-grey" data-id="element-209">
            Try Settl risk-free for 30 days. If you're not completely satisfied,
            let us know and we'll refund your subscription fee.
          </p>
        </div>
      </div>
    </section>;
};
export default Pricing;